﻿define(['jquery', 'pubsub', 'moduleUtilities', 'generalUtilities'], function loadMoreControl(
	$,
	pubsub,
	moduleUtilities,
	generalUtilities
) {
	'use strict';

	var elements, selectors, module, values;

	module = {};
	module.private = {};
	module.properties = {};
	module.state = {};

	elements = {};
	selectors = {};
	values = {};

	elements.html = $('html');

	values.cacheSuffix = '-cache';
	values.responsePrefix = 'data';
	values.requestPrefix = 'uiNeeds';
	values.loadMoreIntent = 'more';
	values.initEvent = 'uiWantsLoadMoreInit';

	selectors.loadMoreBtn = '.js-loadmore-btn';
	selectors.searchForm = '.js-loadmore-form';
	selectors.searchInputs = '.js-loadmore-input';
	selectors.submitBtn = '.js-loadmore-searchbtn';

	module.state.skipCount = 0;
	module.state.cache = {};
	module.state.rowItemRemainder = 0;

	module.private.handleMoreDataRequest = function handleMoreDataRequest(msg, data) {
		var count, dataLength, morePages, nextData, rowItemRemainder;

		count = generalUtilities.prop(data, 'response.Count');
		dataLength = generalUtilities.prop(data, 'response.Data.length');

		// if this is the result of a cache request
		if (data.guid === values.cacheGUID) {
			// put the data into cache
			module.state.cache = data;
			// remove the cache suffix from the request
			module.state.cache.guid = module.state.cache.guid.replace(values.cacheSuffix, '');
			// reveal the button
			$(selectors.loadMoreBtn).css('display', 'block');
			return false;
		}

		// if this is not our event exit (cache events handled above)
		if (!moduleUtilities.isOwnEvent(data, module.properties)) {
			return false;
		}

		// hide the button, if we get more results for the cache it will be revealed
		$(selectors.loadMoreBtn).css('display', 'none');

		// if this is a new search reset the skipCount and module.state.cache
		if (data.intent !== values.loadMoreIntent) {
			module.state.skipCount = 0;
			module.state.cache = {};
		}

		// if the count is greater than the current index then there are more pages
		morePages = count > dataLength + module.state.skipCount;

		// if there are more pages
		if (morePages) {
			if (module.state.rowItemRemainder) {
				rowItemRemainder = module.state.rowItemRemainder(data);

				// decrease the skip count
				module.state.skipCount += data.response.Data.length - rowItemRemainder;
			} else {
				// increment the skip count
				module.state.skipCount += data.response.Data.length
			}
			// copy the incoming date prior to updating it
			nextData = $.extend({}, data);

			// if padding was used for the 1st request it will not be for the 2nd
			// this is for the 'add agent' tile which appears on page 1 of some searches
			if (nextData.padding === 1) {
				nextData.request.RecordCount++;
				nextData.padding = 0;
			}

			// add the cache suffix and update the intent
			nextData.guid += values.cacheSuffix;
			nextData.intent = values.loadMoreIntent;

			// update the skipcount in the request
			// depending on the service it will exist in 1 of 2 places
			if (nextData.request.criteria) {
				nextData.request.criteria.SkipCount = module.state.skipCount;
			} else {
				nextData.request.SkipCount = module.state.skipCount;
			}

			delete nextData.response;

			// republish the event to get the next page for cache
			pubsub.publish(module.state.watchedService, nextData);

			return false;
		}

		return false;
	};

	module.private.handleLoadMoreClick = function handleLoadMoreClick(e) {
		e.preventDefault();

		// publish the cached data as if it came from the webservice
		pubsub.publish(module.state.watchedEvent, module.state.cache);

		pubsub.publish('mixpanel.Intent', { type: 'load more', from: module.properties.mpDataFrom });
	};

	module.private.init = function init(msg, data) {
		module.state.watchedEvent = data.watch;
		module.state.watchedService = data.watch.replace(values.responsePrefix, values.requestPrefix);
		module.state.rowItemRemainder = data.rowItemRemainder;
		module.properties.guid = data.guid;
		module.properties.mpDataFrom = data.mpDataFrom;
		values.cacheGUID = module.properties.guid + values.cacheSuffix;

		pubsub.subscribe(module.state.watchedEvent, module.private.handleMoreDataRequest);

		elements.html.on('click', selectors.loadMoreBtn, module.private.handleLoadMoreClick);
	};

	pubsub.subscribe(values.initEvent, module.private.init);

	return module;
});
